import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@/components/Tooltip';
import Link from '@/components/Link';
import Image from '@/components/Image';

function Trainer({ title, uri, featuredImage, showName, innerRef }) {
  return (
    <Link className="inline-flex" href={uri} ref={innerRef}>
      <div className="flex items-center space-x-4">
        <div className="w-16 h-16 rounded-full">
          <Image
            src={featuredImage.node.sourceUrl}
            alt={title}
            className="block w-16 h-16 rounded-full"
          />
        </div>
        {showName && (
          <div className="flex flex-col space-y-2 lg:space-y-1">
            <div className="font-semibold text-lg lg:text-xl leading-none">
              {title}
            </div>
            <div className="leading-none text-gray-500 text-sm lg:text-lg">
              Entrenador
            </div>
          </div>
        )}
      </div>
    </Link>
  );
}

Trainer.defaultProps = {
  showName: false,
};

Trainer.propTypes = {
  showName: PropTypes.bool,
};

const TrainerWithReference = forwardRef((props, ref) => (
  <Trainer {...props} innerRef={ref} />
));

export default function ClassTrainers({ trainers }) {
  if (trainers === undefined || trainers === null || trainers.lenngth === 0) {
    return null;
  }

  const moreThanTwoTrainers = trainers.length > 2;

  return (
    <div className="flex items-center space-x-2 lg:space-x-4">
      {trainers.map(({ id, title, ...trainer }) => (
        <Tooltip key={id} tooltip={title}>
          <TrainerWithReference
            title={title}
            showName={moreThanTwoTrainers === false}
            {...trainer}
          />
        </Tooltip>
      ))}
    </div>
  );
}
